import InlineSelector from './InlineSelector'

export default InlineSelector
